import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import styles from '../StaticBanner.module.scss';

type Props = {
    onClick: () => void;
    inline?: boolean;
}

const CloseButton: React.FC<Props> = ({ onClick, inline = false }) => {
    return (
        <button
            className={inline ? styles.closeButtonInline : styles.closeButton}
            onClick={(e) => {
                e.stopPropagation();
                onClick();
            }}
            aria-label="Close"
        >
            <CloseOutlined />
        </button>
    );
};

export default CloseButton;
